import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Receipt, CheckCircle2, Clock, XCircle, HelpCircle, ArrowRight } from "lucide-react";

const rupiah = (n) => "Rp " + Number(n || 0).toLocaleString("id-ID");
const STATUS = {
  pending: { label: "Belum dikonfirmasi", cls: "bg-[var(--surface-hover)] text-[var(--text-secondary)]", icon: HelpCircle },
  waiting_verification: { label: "Menunggu verifikasi", cls: "bg-[var(--amber)]/15 text-amber", icon: Clock },
  approved: { label: "Disetujui · Aktif", cls: "bg-[var(--bull)]/15 text-bull", icon: CheckCircle2 },
  rejected: { label: "Ditolak", cls: "bg-[var(--bear)]/15 text-bear", icon: XCircle },
};
const fmt = (iso) => { try { return new Date(iso).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" }); } catch { return "-"; } };

export default function MyOrders({ refreshKey }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (!user) { setOrders([]); return; }
    api.get("/manual/my-orders").then((r) => setOrders(r.data.orders || [])).catch(() => {});
  }, [user, refreshKey]);

  if (!user || orders.length === 0) return null;

  const latest = orders[0];
  const s = STATUS[latest.status] || STATUS.pending;
  const Icon = s.icon;

  return (
    <div className="card p-5 mb-8" data-testid="my-orders">
      <p className="font-heading font-bold flex items-center gap-2 mb-4"><Receipt size={16} className="text-accent" /> Riwayat Pesanan Saya</p>
      <div className="flex items-center gap-3 bg-[var(--surface-base)] rounded-lg px-3 py-2.5 border border-[var(--border-subtle)]" data-testid={`my-order-${latest.order_id}`}>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="font-mono-data text-xs text-accent">{latest.order_id}</span>
            <span className="text-[13px] font-semibold">{latest.package_name}</span>
            <span className="text-xs text-[var(--text-muted)]">· {latest.days} hari</span>
          </div>
          <p className="text-[11px] text-[var(--text-muted)] mt-0.5">{fmt(latest.created_at)} · <span className="font-mono-data text-[var(--text-secondary)]">{rupiah(latest.amount_total)}</span></p>
        </div>
        <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold shrink-0 ${s.cls}`} data-testid={`my-order-status-${latest.order_id}`}>
          <Icon size={12} /> {s.label}
        </span>
      </div>
      {orders.length > 1 && (
        <button onClick={() => navigate("/orders")} data-testid="view-all-orders" className="mt-3 w-full inline-flex items-center justify-center gap-1.5 text-sm font-semibold text-accent hover:opacity-80 transition-opacity">
          Lihat semua pesanan ({orders.length}) <ArrowRight size={14} />
        </button>
      )}
    </div>
  );
}
